import { isOneOfEnumControl, JsonFormsRendererRegistryEntry, rankWith } from '@jsonforms/core';
import controlRenderer from './OneOfEnumControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(5, isOneOfEnumControl),
};
